export default class ApiConstants {
    static GET_PRODUCTS = "api/products/filter"
    static ADD_PRODUCT = "api/products"
    static EDIT_PRODUCT = "api/products"
    static UPLOAD_PRODUCT_IMAGE = "api/products/image"
    static LOGIN = "api/login"
    static GET_VENDORS = "api/vendors"
    static ADD_VENDOR = "api/vendor"
    static GET_SKU = "api/vendors/fetch-sku"
    static ADD_PRODUCT_PRICE = "api/vendors/price"
    static UPLOAD_VENDOR_PRICE = "api/vendors/upload-price"
    static GET_PRODUCTS_PRICE = "api/vendors/product"
    static GET_MASTER_DATA = "api/master-data"

    static GET_CUSTOMERS = "api/customers"
    static GET_CUSTOMER_REQUIREMENT = "api/customers/requirement"
    static GET_CUSTOMER_MASTER_DATA = "api/customer-master-data"
    static GET_PRODUCT_REQUIREMENT = "api/customers/productrequirements"
    
    static ADD_CONTACT = "api/contacts"
    static GET_CONTACTS = "api/contacts/filter"

    static QUOTE_VENDORS = "api/quote/vendors"
    static QUOTE_REQUISITIONS = "api/quote/requisitions"
    static QUOTE_VENDOR_RATES = "api/quote/vendor-rates"

    static AUTH_OTP_REQUEST = "api/auth/otp/request"
    static AUTH_OTP_VERIFY = "api/auth/otp/verify"
    static AUTH_ME = "api/auth/me"
    static NOTIFICATIONS = "api/auth/notifications"
    static ORGANIZATIONS = "api/organizations"
    static PORTAL = "api/portal"
    static QUOTE_REQUIREMENTS = "api/quote/requirements"
    static ORDERS = "api/orders"
    static CATALOGUE = "api/catalogue"
    static SOURCING = "api/sourcing"
    static DASHBOARD = "api/dashboard"
    static REPORTS = "api/reports"
}